import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB1gLeXiKY7KygKzHuB80qJVY18Binw8ME",
  authDomain: "arcseg-portal.firebaseapp.com",
  projectId: "arcseg-portal",
  storageBucket: "arcseg-portal.firebasestorage.app",
  messagingSenderId: "545627815276",
  appId: "1:545627815276:web:a5c9cd6759ceb7f239c749"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({ hd: 'arcseg-ec.com' });

export const loginWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logout = () => signOut(auth);